import {createApp} from 'vue'
import App from './App.vue'
import router from './router/index';

import {IonicVue, /* createAnimation, */ iosTransitionAnimation} from '@ionic/vue';
/* Core CSS required for Ionic components to work properly */
import '@ionic/vue/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/vue/css/normalize.css';
import '@ionic/vue/css/structure.css';
import '@ionic/vue/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/vue/css/padding.css';
import '@ionic/vue/css/float-elements.css';
import '@ionic/vue/css/text-alignment.css';
import '@ionic/vue/css/text-transformation.css';
import '@ionic/vue/css/flex-utils.css';
import '@ionic/vue/css/display.css';
import '@/theme/fontawesome.min.css';
import '@/theme/datatables.css';
import '@/theme/animate.compat.css';
// import '@/theme/';
import '@/theme/style.css';

/* Theme variables */
import './theme/variables.css';
import './theme/filemanager.css';

// const myAnimation = (baseEl, opts) => {
//   const { enteringEl, leavingEl } = opts;
//
//   const enteringPage = createAnimation('entering-page-animation')
//     .addElement(enteringEl)
//     .fromTo('opacity', 1, 0);
//
//   const leavingPage = createAnimation('leaving-page-animation')
//     .addElement(leavingEl)
//     .fromTo('opacity', 0, 1);
//
//   return createAnimation('root-transition')
//     .duration(500)
//     .easing('ease-in-out')
//     .addAnimation([enteringPage, leavingPage]);
// }
//
// console.log(typeof myAnimation)

const app = createApp(App)
  .use(IonicVue, {
    mode : 'md',
    navAnimation: iosTransitionAnimation
  })
  .use(router);
import store from '/src/store';

app.use(store)

import MasterLayout from './components/MasterLayout';
import {IonPage} from '@ionic/vue';

app.component('master-layout', MasterLayout);
app.component('IonPage', IonPage);

router.isReady().then(() =>
{
  window.$ = window.jquery = require('jquery');
  window.dt = require('datatables.net');
  require('@/shared/script')
  require('@/shared/filemanager')
  app.mount('#app');
});